import React, { useState } from "react";
import { FaUser, FaEnvelope, FaPhone, FaComment, FaWhatsapp, FaMapMarkerAlt } from "react-icons/fa";
import { Helmet } from "react-helmet";
import "./Contact.css";

const Contact = () => {
  const [status, setStatus] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    const formData = new FormData(e.target);

    fetch("https://formspree.io/f/xkoqqrnk", {
      method: "POST",
      body: formData,
      headers: { Accept: "application/json" },
    })
      .then((response) => {
        if (response.ok) {
          setStatus("✅ Message received. We'll contact you shortly.");
          e.target.reset();
          setTimeout(() => setStatus(""), 5000);
        } else {
          setStatus("❌ Error sending message.");
        }
      })
      .catch(() => setStatus("❌ Connection error."))
      .finally(() => setSubmitting(false));
  };

  return (
    <main className="contact-page-root">
      <Helmet>
        <title>Connect | Skyline Bussiness Solutions</title>
        <meta name="description" content="Reach out to the Skyline Bussiness Solutions engineering team for digital transformation and growth." />
      </Helmet>

      <div className="contact-grid">
        {/* LEFT: Info Panel */}
        <aside className="contact-info-panel">
          <span className="contact-badge">GET IN TOUCH</span>
          <h1 className="contact-title">Let's build <br/><span>something great.</span></h1>
          
          <div className="info-cards">
            <div className="info-item">
              <FaMapMarkerAlt className="info-icon" />
              <div>
                <h4>Visit Our Studio</h4>
                <p>Livewire Building, 2nd Floor, Bombay Hospital Area, Indore</p>
              </div>
            </div>
            
            <div className="info-item">
              <FaWhatsapp className="info-icon" />
              <div>
                <h4>Instant Support</h4>
                <p>+91 96300 85601</p>
                <a href="https://wa.me/919630085601" className="chat-link">Start Chat —</a>
              </div>
            </div>
          </div>
        </aside>

        {/* RIGHT: Form Panel */}
        <section className="contact-form-panel">
          <div className="glass-form-card">
            <form onSubmit={handleSubmit} className="pro-form">
              <div className="field-row">
                <div className="input-box">
                  <label>Full Name</label>
                  <input type="text" name="name" placeholder="John Doe" required />
                </div>
              </div>

              <div className="field-row split">
                <div className="input-box">
                  <label>Email Address</label>
                  <input type="email" name="email" placeholder="john@example.com" required />
                </div>
                <div className="input-box">
                  <label>Phone Number</label>
                  <input type="tel" name="phone" placeholder="+91 00000 00000" required />
                </div>
              </div>

              <div className="input-box">
                <label>Message</label>
                <textarea name="message" placeholder="Tell us about your project..." required></textarea>
              </div>

              <button type="submit" className="pro-submit-btn" disabled={submitting}>
                {submitting ? "Processing..." : "Submit Inquiry"}
              </button>
            </form>
            {status && <p className="status-toast">{status}</p>}
          </div>
        </section>
      </div>
    </main>
  );
};

export default Contact;